import { Pastille } from '../ui/Primitives';

/** Fonction du lecteur sans donnée en base : annoncée, jamais remplie de données fictives. */
export function BandeauIndisponible({ message }: { message: string }): JSX.Element {
  return (
    <div className="rounded-2xl bg-amber-50 p-4 text-sm sm:p-5">
      <Pastille texte="Indisponible" ton="warning" />
      <p className="mt-2 leading-relaxed text-codialis-gray">{message}</p>
    </div>
  );
}
